import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountries } from '../../actions/countriesActions';

const useCountries = (lang: string, filter: boolean = false) => {
	const dispatch = useDispatch<any>();
	const { countries, countriesError, countriesLoading } = useSelector(({ countriesReducer }) => countriesReducer);
	useEffect(() => {
		if (countries === null && !countriesError && !countriesLoading) {
			dispatch(fetchCountries(lang, filter));
		}
	}, [countries, countriesError, countriesLoading, dispatch, lang, filter]);

	return {
		countries,
		countriesError,
		countriesLoading,
	};
};

export default useCountries;
